import { Typography } from "@mui/material"
import { DynamicConfigField, DynamicConfigKey, MeetingServiceConfig } from "../../form/formTypes"
import { SelectedMainUserState } from "../../../createOrderTypes"
import { FieldRenderer } from "./FieldRenderer"

type GroupFieldsProps = {
    title?: string
    fields: DynamicConfigField[]
    meetingServiceConfiguration: MeetingServiceConfig
    user: SelectedMainUserState
    defaultButtonClass?: string
    deliveryFields: {
        deliveryLocations?: DynamicConfigField
        otherDeliveryLocation?: DynamicConfigField
    }
    showOtherLocationField: boolean
    setShowOtherLocationField: (v: boolean) => void
    hasMeetingTimeRequired?: boolean
    hasMeetingLocationRequired?: boolean
}

export function GroupFields({
    title,
    fields,
    meetingServiceConfiguration,
    user,
    defaultButtonClass,
    deliveryFields,
    showOtherLocationField,
    setShowOtherLocationField,
    hasMeetingTimeRequired,
    hasMeetingLocationRequired,
}: GroupFieldsProps) {
    const isRecurrence = fields.some((f) => f.key === DynamicConfigKey.RECURRENCY)
    const isCreateBuyerParty = fields.find((el) => el.key === DynamicConfigKey.CREATE_BUYER_PARTY)?.active
    const showGroupTitle = Boolean(title) && !isRecurrence && fields.some((f) => f.active)

    return (
        <>
            {showGroupTitle && <Typography variant="subtitle1">{title}</Typography>}
            {fields.map((config) => (
                <FieldRenderer
                    key={config.key}
                    config={config}
                    groupTitle={title}
                    meetingServiceConfiguration={meetingServiceConfiguration}
                    user={user}
                    defaultButtonClass={defaultButtonClass}
                    deliveryFields={deliveryFields}
                    showOtherLocationField={showOtherLocationField}
                    setShowOtherLocationField={setShowOtherLocationField}
                    isCreateBuyerParty={isCreateBuyerParty}
                    hasMeetingTimeRequired={hasMeetingTimeRequired}
                    hasMeetingLocationRequired={hasMeetingLocationRequired}
                />
            ))}
        </>
    )
}
